import React from 'react';
import { useTranslation } from 'react-i18next';
import { PointsServices } from '@components/templates/marketplace';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';
import { FiltersProvider } from '@context';

export function PointsServicesPage() {
    const { allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        title: t('points-services-component.metatags.title', { marketplace: allSettings?.data?.marketplaceName }),
        description: t('points-services-component.metatags.description', { marketplace: allSettings?.data?.marketplaceName }),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        // image: #TODO
        url: SITE_URLS.pointsServices,
        index: true,
    });

    return (
        <FiltersProvider>
            <PointsServices />
        </FiltersProvider>
    );
}
